import React from "react";
import { injectIntl } from "react-intl";
import Breadcrumb from "../../common/Breadcrumb";
import ButtonBack from "../../common/ButtonBack";
import Propertii from "../../common/Propertii";
import PaymentMethodAuditReport from "../../common/ReportPaymentMethodAudit";

class PaymentMethodAudit extends Propertii {

    /**
     * Render the component.
     *
     * @returns {*} - The company Payment Method Audit report component.
     */
    render() {

        return(
            <div className="content-block">

                <div className="container">

                    <Breadcrumb parentPath="/manager/reports" parentPage="Reports" childPage="Payment Method" />

                    <PaymentMethodAuditReport companyId={this.props.userSession.sessionRole.companyId} />

                    <div className="row">
                        <div className="col text-right">
                            <ButtonBack path="/manager/reports" />
                        </div>
                    </div>

                </div>

            </div>
        )
    };
}

export default injectIntl(PaymentMethodAudit);